if (!customElements.get("header-section")) {
  customElements.define(
    "header-section",
    class HeaderSection extends HTMLElement {
      lastScrollPosition;
      isHeaderVisible;
      isAtTop;
      isScrollingDown;
      parentHeader;
      announcementBarRoot;
      hamburgerButton;
      mobileMenu;
      megaMenuDropdowns;
      hamburgerOpenIcon;
      hamburgerCloseIcon;
      panelStack;
      menuKeydownHandler = null;
      menuTouchmoveHandler = null;
      activeMenuContainer = null;
      constructor() {
        super();
        this.lastScrollPosition = window.scrollY;
        this.isHeaderVisible = true;
        this.isAtTop = true;
        this.isScrollingDown = null;
        this.parentHeader = this.closest("#shopify-section-header");
        this.announcementBarRoot = document.querySelector("[data-announcement-bar-root]");
        this.hamburgerButton = this.querySelector("[data-hamburger-button]");
        this.mobileMenu = this.querySelector("[data-menu-mobile]");
        this.megaMenuDropdowns = this.querySelectorAll("[data-mega-menu-dropdown-el]");
        this.hamburgerOpenIcon = this.querySelector("#mobile-burger-open-icon");
        this.hamburgerCloseIcon = this.querySelector("#mobile-burger-close-icon");
        this.panelStack = [];
      }
      handleScroll() {
        const currentScrollPosition = window.scrollY;
        const isScrollingDown = currentScrollPosition > this.lastScrollPosition;
        const isAtTop = currentScrollPosition === 0;
        if (isScrollingDown !== this.isScrollingDown || isAtTop !== this.isAtTop) {
          this.isScrollingDown = isScrollingDown;
          this.isAtTop = isAtTop;
          if (isAtTop && this.parentHeader) {
            this.style.transform = "translateY(0)";
            this.isHeaderVisible = true;
          } else if (isScrollingDown && this.isHeaderVisible && this.parentHeader) {
            this.style.transform = "translateY(-130%)";
            this.isHeaderVisible = false;
          } else if (!isScrollingDown && !this.isHeaderVisible && this.parentHeader) {
            this.style.transform = "translateY(0)";
            this.isHeaderVisible = true;
          }
          if (this.parentHeader) {
            this.parentHeader.style.top = this.isHeaderVisible ? "0px" : "-34px";
          }
          if (this.announcementBarRoot) {
            this.announcementBarRoot.style.transform = this.isHeaderVisible ? "translateY(0)" : "translateY(-100%)";
          }
        }
        this.lastScrollPosition = currentScrollPosition;
      }
      getFocusableMenuElements() {
        const container = this.activeMenuContainer;
        if (!container) return [];
        return Array.from(
          container.querySelectorAll(
            'a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]'
          )
        ).filter((el) => !el.closest("[inert]"));
      }
      pushPanel(panel, trigger) {
        if (this.panelStack.length === 0) {
          this.mobileMenu?.querySelector("[data-menu-main-content]")?.setAttribute("inert", "");
          this.mobileMenu?.querySelector("[data-menu-search]")?.setAttribute("inert", "");
        } else {
          this.panelStack[this.panelStack.length - 1].panel.querySelector(":scope > [data-panel-scroll]")?.setAttribute("inert", "");
        }
        panel.classList.add("open-panel");
        panel.removeAttribute("inert");
        panel.setAttribute("aria-hidden", "false");
        this.panelStack.push({ panel, trigger });
        this.activeMenuContainer = panel;
        requestAnimationFrame(() => {
          panel.querySelector(":scope > [data-panel-scroll]")?.querySelector("button:not([disabled]), a[href]")?.focus();
        });
      }
      popPanel() {
        const entry = this.panelStack.pop();
        if (!entry) return;
        const { panel, trigger } = entry;
        panel.classList.remove("open-panel");
        panel.addEventListener(
          "transitionend",
          () => {
            panel.setAttribute("inert", "");
            panel.setAttribute("aria-hidden", "true");
          },
          { once: true }
        );
        if (this.panelStack.length === 0) {
          this.mobileMenu?.querySelector("[data-menu-main-content]")?.removeAttribute("inert");
          this.mobileMenu?.querySelector("[data-menu-search]")?.removeAttribute("inert");
          this.activeMenuContainer = this.mobileMenu;
        } else {
          this.panelStack[this.panelStack.length - 1].panel.querySelector(":scope > [data-panel-scroll]")?.removeAttribute("inert");
          this.activeMenuContainer = this.panelStack[this.panelStack.length - 1].panel;
        }
        trigger.focus();
      }
      cleanupAfterClose() {
        this.panelStack.forEach(({ panel }) => {
          panel.classList.remove("open-panel");
          panel.setAttribute("inert", "");
          panel.setAttribute("aria-hidden", "true");
        });
        this.panelStack = [];
        this.mobileMenu?.querySelector("[data-menu-main-content]")?.removeAttribute("inert");
        this.mobileMenu?.querySelector("[data-menu-search]")?.removeAttribute("inert");
        this.activeMenuContainer = null;
        this.hamburgerButton?.classList.remove("is-active");
        this.hamburgerOpenIcon?.classList.remove("hidden");
        this.hamburgerCloseIcon?.classList.add("hidden");
        document.querySelector("body")?.classList.remove("overflow-hidden");
        if (this.menuTouchmoveHandler) {
          document.removeEventListener("touchmove", this.menuTouchmoveHandler);
          this.menuTouchmoveHandler = null;
        }
        if (this.menuKeydownHandler) {
          document.removeEventListener("keydown", this.menuKeydownHandler);
          this.menuKeydownHandler = null;
        }
        this.hamburgerButton?.focus();
      }
      openMobileMenu() {
        if (!this.mobileMenu) return;
        this.panelStack = [];
        const headerBottom = this.getBoundingClientRect().bottom;
        this.mobileMenu.style.top = `${headerBottom}px`;
        this.hamburgerButton?.classList.add("is-active");
        this.hamburgerOpenIcon?.classList.add("hidden");
        this.hamburgerCloseIcon?.classList.remove("hidden");
        document.querySelector("body")?.classList.add("overflow-hidden");
        this.activeMenuContainer = this.mobileMenu;
        this.menuTouchmoveHandler = (e) => {
          const target = e.target;
          if (this.mobileMenu?.querySelector("[data-menu-main-content]")?.contains(target)) return;
          const panelScrolls = this.mobileMenu?.querySelectorAll("[data-panel-scroll]") ?? [];
          for (const scroll of Array.from(panelScrolls)) {
            if (scroll.contains(target)) return;
          }
          e.preventDefault();
        };
        document.addEventListener("touchmove", this.menuTouchmoveHandler, { passive: false });
        const onCancel = (e) => {
          if (this.panelStack.length > 0) {
            e.preventDefault();
            this.popPanel();
          }
        };
        this.mobileMenu.addEventListener("cancel", onCancel);
        this.mobileMenu.addEventListener("close", () => {
          this.mobileMenu?.removeEventListener("cancel", onCancel);
          this.cleanupAfterClose();
        }, { once: true });
        this.mobileMenu.showModal();
        requestAnimationFrame(() => {
          const focusable = this.getFocusableMenuElements();
          focusable[0]?.focus();
        });
      }
      closeMobileMenu() {
        this.mobileMenu?.close();
      }
      handleHamburgerClick() {
        if (this.mobileMenu && this.hamburgerButton) {
          window.closeMobileMenu = () => this.closeMobileMenu();
          this.hamburgerButton.addEventListener("click", () => {
            if (this.mobileMenu?.open) {
              this.closeMobileMenu();
            } else {
              this.openMobileMenu();
            }
          });
        }
      }
      handleMobileMenuClick() {
        if (!this.mobileMenu) return;
        this.mobileMenu.addEventListener("click", (e) => {
          const trigger = e.target.closest(
            "[data-mobile-menu-dropdown-el]"
          );
          if (!trigger) return;
          const type = trigger.dataset.mobileMenuDropdownEl;
          if (type === "open") {
            const panelId = trigger.dataset.panelTarget;
            const panel = panelId ? document.getElementById(panelId) : trigger.parentElement?.querySelector(
              "[data-mobile-menu-dropdown-panel-el]"
            );
            if (panel) this.pushPanel(panel, trigger);
          } else if (type === "close") {
            this.popPanel();
          }
        });
      }
      handleMegaMenuHover() {
        if (this.megaMenuDropdowns) {
          this.megaMenuDropdowns.forEach((dropdown) => {
            dropdown.addEventListener("mouseenter", () => {
              document.body.classList.add("overflow-hidden");
            });
            dropdown.addEventListener("mouseleave", () => {
              document.body.classList.remove("overflow-hidden");
            });
          });
        }
      }
      init() {
        window.addEventListener("scroll", () => this.handleScroll());
        this.handleHamburgerClick();
        this.handleMobileMenuClick();
        this.handleMegaMenuHover();
      }
      connectedCallback() {
        this.init();
      }
    }
  );
}
